export default __webpack_public_path__ + "images/0674765aa1df7d6296d1fa155c3e31eb.png";